export default {
  signed: 'Signed', //	Accounts which have signed their contracts but not yet gone live
  live: 'Live', // Went live (has widget enabled and/or marketing material in store), all verifications done, but is not transacting yet and/or has not yet reached the minimum threshold.
  active: 'Active', //	The account is processing at least 1 txn per month
  inactive: 'Inactive', //	The account was previously active, but has not transacted in over 1 month and/or has not met the minimum threshold excluding the current month
  churned: 'Churned', // Account has 3 consecutive months with zero or negative sales, excluding the current month
  cancelled: 'Cancelled', // The account was cancelled by the merchant (i.e. merchant explicitly informed us that they no longer want to leverage Tamara's services)
  terminated: 'Terminated', // The account was terminated by Tamara due to a breach of contract - manually updated by PSM
  suspended: 'Suspended',
  lost: 'Lost', //	Not because of termination or cancelled
  test: 'Test', //	Accounts on admin
  obsolete: 'Obsolete', //	Accounts created by mistake - not functioning
}
